import { MAX_CHARS_REGISTER_BUTTON } from './variables';

export const isValidRegisterButtonText = (text?: string): boolean => {
  if (text && text.trim().length > MAX_CHARS_REGISTER_BUTTON) return false;
  return true;
};
